import { useMutation } from '@tanstack/react-query';
import { shareProperty } from '../../../api/Property/shareProperty';

export function useShareProperty() {
  const updatePropertyMutationFunction = async ({ id, email }) => {
    const requestBody = {
      id: id,
      email: email,
    };
    return await shareProperty({ id: id, requestBody: requestBody });
  };

  const sharePropertyMutation = useMutation({
    mutationFn: (body: { id: string; email: string }) =>
      updatePropertyMutationFunction(body),
  });

  return {
    shareProperty: sharePropertyMutation.mutateAsync,
    isSuccess: sharePropertyMutation.isSuccess,
    isError: sharePropertyMutation.isError,
    isPending: sharePropertyMutation.isPending,
    error: sharePropertyMutation.error,
    response: sharePropertyMutation.data,
  };
}
